import { useMemo } from 'react';

// Cheap CSS-only confetti — 36 square shards falling with random drift,
// rotation, and color from a 6-stop palette. Renders nothing when not
// active so it can sit mounted as an overlay.
const COLORS = ['#FF3E7F', '#FF6B4A', '#FFD166', '#5BE9FF', '#C09CFF', '#FFE9B8'];

export default function Confetti({ active, pieces = 36, duration = 2400 }) {
  const shards = useMemo(() => {
    if (!active) return [];
    return Array.from({ length: pieces }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      delay: Math.random() * 400,
      drift: (Math.random() - 0.5) * 160,
      rotate: Math.random() * 720,
      color: COLORS[i % COLORS.length],
      size: 6 + Math.random() * 6
    }));
  }, [active, pieces]);

  if (!active) return null;
  return (
    <div style={{ position: 'fixed', inset: 0, pointerEvents: 'none', overflow: 'hidden', zIndex: 250 }}>
      {shards.map((s) => (
        <span
          key={s.id}
          style={{
            position: 'absolute',
            top: -20,
            left: `${s.left}%`,
            width: s.size, height: s.size,
            background: s.color,
            borderRadius: 1,
            animation: `og-confetti-fall ${duration}ms cubic-bezier(.2,.6,.4,1) ${s.delay}ms forwards`,
            '--og-drift': `${s.drift}px`,
            '--og-rotate': `${s.rotate}deg`
          }}
        />
      ))}
      <style>{`
        @keyframes og-confetti-fall {
          0%   { opacity: 0; transform: translateY(0)               translateX(0)              rotate(0deg); }
          10%  { opacity: 1; }
          90%  { opacity: 1; }
          100% { opacity: 0; transform: translateY(calc(100vh + 60px)) translateX(var(--og-drift)) rotate(var(--og-rotate)); }
        }
      `}</style>
    </div>
  );
}
